import '../Div/index.js';
import { Pressable } from '../Button.js';
import { Text } from '../Text.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
function SelectOptions({
  optionValues,
  changeHandler,
  selectedOption,
  top
}) {
  if (optionValues.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsx(Div, {
    flexDirection: "column",
    position: "absolute",
    top: top,
    width: "100%",
    background: "background",
    elevation: 1,
    zIndex: 1,
    maxHeight: "560px",
    borderRadius: "rounded",
    maxWidth: "inherit",
    overflow: "auto",
    children: optionValues?.map((option, index) => /*#__PURE__*/jsx(Pressable, {
      as: "button",
      background: selectedOption?.value === option.value ? 'backgroundAlternate' : 'background'
      // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
      ,

      onPress: () => changeHandler(option),
      borderRadius: "rounded",
      noScaleOnPress: true,
      children: /*#__PURE__*/jsx(Div, {
        flexDirection: "column",
        spacingHorizontal: 3,
        spacingVertical: 1,
        minHeight: 56,
        justifyContent: "center",
        children: /*#__PURE__*/jsx(Text, {
          variant: "headline",
          as: "p",
          overflow: "truncate",
          color: "foreground",
          css: {
            textAlign: 'start'
          },
          children: option.label
        })
      })
    }, `select-option-${index}`))
  });
}
export { SelectOptions };
//# sourceMappingURL=SelectOptions.js.map
